<template>
    <div :class="navigateButtons && 'p-ai-center p-grid p-jc-center'">
        <div
                :class="navigateButtons && 'p-col'"
        >
            <div :class="navigateButtons && 'p-inputgroup'">
                <Button
                        v-if="navigateButtons"
                        v-tooltip.top="'היום הקודם'"
                        @click="navigate(false)"
                        icon="pi pi-angle-right"
                        class="minus p-button-secondary p-inputgroup-addon"
                ></Button>


                <Calendar
                        :autoZIndex="autoZIndex"
                        :baseZIndex="100"
                        :mask="true"
                        :touchUI="touchUI"
                        v-on="listeners"
                        :manualInput="false"
                        :disabledDays="[6]"
                        v-model="selectedDate"
                        :showButtonBar="true"
                        :dateFormat="dateformat"
                />

                <Button
                        v-if="navigateButtons"
                        v-tooltip.top="'היום הבא'"
                        @click="navigate(true)"
                        icon="pi  pi-angle-left"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {dateToFullHebrew} from "@/utils/hebrewDateFormat";

export default {
    data() {
        return {
            display: "20vw",
            selectedDate: null
        }
    },
    props: {
        storageName: {
            type: String,
            default: "default"
        },
        baseZIndex: {
            type: Number,
            default: 1000
        },
        navigateButtons: {
            type: Boolean,
            default: false
        },
        autoZIndex: {
            type: Boolean,
            default: true
        },
        touchUI: {
            type: Boolean,
            default: true
        },
        useStore: {
            type: Boolean,
            default: false
        },
        replaceOptions: {
            type: Array,
            default: null
        },
        value: null
    },
    name: "SelectDate",
    computed: {
        dateformat() {
            return dateToFullHebrew(this.selectedDate);
        },
        listeners() {
            return {
                ...this.$listeners,
                input: event => {
                    console.log("eventevent",event)
                    // this.$emit('input', event);
                    this.onSelect({originalEvent: null, value: event})

                }
            };
        },
    },
    created() {
        console.log("this.value",this.value)
        this.selectedDate = this.value
        window.addEventListener("resize", this.onResize);

        if (this.useStore) {
            const restoreDate = Vue.ls.get(`selectDate_${this.storageName}`)
            if (restoreDate){
                this.onSelect({originalEvent: null, value: new Date(restoreDate)})
            }else {
                this.onSelect({originalEvent: null, value: new Date()})

            }
        }  else {
            this.onSelect({originalEvent: null, value: this.value || new Date()})

        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        onResize() {
            if (window.innerWidth < 576) {
                this.display = "40vw";
            } else {
                this.display = "10px";
            }
        },
        navigate(isAdd) {
           const operator = isAdd ? + 1: -1
            const currentDate = this.selectedDate
           const updateDate = currentDate.setDate(currentDate.getDate() + operator)
            this.selectedDate = new Date(updateDate)
            this.onSelect({originalEvent: null, value: this.selectedDate})
        },
        onSelect({originalEvent, value}) {
            Vue.ls.set(`selectDate_${this.storageName}`, value)
            this.selectedDate = value

            this.$emit('input', value);
            this.$emit('onSelect', value);
        }
    },
}
</script>

<style scoped>

</style>